import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SupportChatThread from "./SupportChatThread";
import chat from "../../Clinic/common/chat.module.css";

function BackChevron() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden>
      <path
        d="M14.5 6.5L9 12l5.5 5.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function SupportConversationPage({
  mode,
  threadKey = null,
  title = "Поддержка Бай.Спорт",
  subtitle = "Команда платформы",
  backTo,
  fullscreen = true,
  hideBack = false,
  /** admin | client | owner — влияет на полноэкранную вёрстку, mode — на API */
  shell = null,
  onMeta,
}) {
  const navigate = useNavigate();
  const uiShell =
    shell || (mode === "owner" ? "owner" : mode === "club" ? "client" : "admin");

  useEffect(() => {
    if (!fullscreen) return undefined;
    const cls =
      uiShell === "client"
        ? "client-chat-open"
        : uiShell === "owner"
          ? "owner-chat-open"
          : "admin-chat-open";
    document.documentElement.classList.add(cls);
    return () => document.documentElement.classList.remove(cls);
  }, [fullscreen, uiShell]);

  const shellClass = fullscreen
    ? uiShell === "client"
      ? `${chat.chatScreenPage} chatScreenPage`
      : `${chat.chatScreenAdmin} chatScreenAdmin`
    : `${chat.chatHubThread} chatHubThread`;

  return (
    <div className={shellClass}>
      <header className={chat.chatHeader}>
        {!hideBack && backTo ? (
          <button
            type="button"
            className={chat.chatHeaderBack}
            onClick={() => navigate(backTo)}
            aria-label="Назад"
          >
            <BackChevron />
          </button>
        ) : null}
        <span className={chat.chatInboxAvatarClub} aria-hidden>
          🛟
        </span>
        <div className={chat.chatHeaderMain}>
          <h1 className={chat.chatHeaderTitle}>{title}</h1>
          {subtitle ? <p className={chat.chatHeaderSub}>{subtitle}</p> : null}
        </div>
      </header>
      <SupportChatThread
        mode={mode === "platform" ? "platform" : mode === "owner" ? "owner" : "club"}
        threadKey={threadKey}
        onMeta={onMeta}
      />
    </div>
  );
}
